import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import PdfDocument from "../merchant/PdfDocument";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import Loading from "../../shared/component/others/Loading";
import {SERVER_URL} from '../../shared/utils/Constants';
import '../../shared/styles/SettingsPage.css';


const defaultBarcode = {
    url: null
};
export default class BarcodeGenerator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            barcode: defaultBarcode,
            loading: false,
            barcodeSource: ''

        }
        this.merchantBranchService = new MerchantBranchService();
    }


    componentDidMount() {
        let obj1 = Object.assign({}, defaultBarcode);
        obj1.url=SERVER_URL.replace("/posmarket/","","/service/","");
        this.setState({
            barcode: obj1
        });

    }


    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Barcode Generator</h1>
                        </div>
                        <div className="settings-page__panel">
                            {this.barcodeDetails()}
                            {this.barcodeReport()}
                        </div>
                    </div>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    barcodeDetails() {

        return (
            <FormSection title="Qr Code">

                <Row>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="tax.tradingName">Url</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="url"
                                disabled={false}
                                validate={{
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "You can enter up to 255 characters in this field."
                                    }
                                }}
                                value={this.state.barcode.url}
                                onChange={this.__handleChange}/>

                        </AvGroup>
                    </Col>
                </Row>

                <div className="settings-page__actions">
                <Button color="outline-primary" className="settings-page__btn--action" onClick={() => {
                    this.downloadBarcode();
                }}>
                    <Translate contentKey="entity.action.add">Download</Translate>
                </Button>

                <Button color="outline-primary" className="settings-page__btn--action" onClick={() => {
                    this.printBarcode();
                }}>
                    <Translate contentKey="entity.action.add">Print</Translate>
                </Button>
                </div>

            </FormSection>
        );
    };

    printBarcode = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.barcode.url)) {
            return toast.warn("Empty Url");
        } else {

            this.setState({loading: true});
            this.merchantBranchService.generateBarcodeForAddress(this.state.barcode).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response.file)) {
                    GeneralUtils.printFile(response);
                    this.setState({loading: false});
                }
            });
        }

    }
    downloadBarcode = () => {

        if (GeneralUtils.isNullOrEmpty(this.state.barcode.url)) {
            return toast.warn("Empty Url");
        } else {
            this.setState({loading: true});
            this.merchantBranchService.generateBarcodeForAddress(this.state.barcode).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response.file)) {
                    GeneralUtils.downloadFile(response);
                }
                this.setState({loading: false});
            });
        }

    }
    barcodeReport() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcodeSource)) {
            return (
                <div>
                    <FormSection title="Barcode">
                        <div className="all-page-container">
                            <PdfDocument pdf={this.state.barcodeSource}
                            />
                        </div>
                    </FormSection>
                </div>
            );
        } else {
            return ''
        }
    }




    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let barcode = this.state.barcode;
        barcode[e.target.name] = value;
        this.setState({barcode: barcode});
    }


}

